// src/components/tasks/SectionCreateForm.jsx
import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  useTheme
} from '@mui/material';

/**
 * SectionCreateForm - Form for creating a new section
 * 
 * @param {Object} props - Component props
 * @param {Function} props.onCreateSection - Function to create section
 * @param {Function} props.onCancel - Function to cancel creation
 * @param {boolean} props.autoFocus - Whether to focus the input automatically
 */
const SectionCreateForm = ({
  onCreateSection,
  onCancel,
  autoFocus = true
}) => {
  const theme = useTheme();
  const [sectionName, setSectionName] = useState('');
  const inputRef = useRef(null);
  
  // Focus the input when component mounts
  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);
  
  const handleSubmit = () => {
    if (sectionName?.trim()) {
      onCreateSection(sectionName?.trim());
      setSectionName('');
    }
  };
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && sectionName?.trim()) {
      e.preventDefault();
      handleSubmit();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    }
  };
  
  return (
    <Paper 
      sx={{ 
        p: 2, 
        // borderRadius: theme.shape.borderRadius, 
        mt: 2,
        boxShadow: theme.shadows[2]
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1" fontWeight={600}>
          New Section
        </Typography>
      </Box>
      
      <TextField
        fullWidth
        placeholder="Section name"
        value={sectionName}
        onChange={(e) => setSectionName(e.target.value)}
        onKeyDown={handleKeyDown}
        inputRef={inputRef}
        variant="outlined"
        size="small"
        sx={{ mb: 2 }}
      />
      
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
        <Button
          variant="text"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!sectionName?.trim()}
        >
          Add Section
        </Button>
      </Box>
    </Paper>
  );
};

export default SectionCreateForm;